export default __webpack_public_path__ + "static/ServiceIllustration-57b36b040406aa93f9e0a28c9489ddb7.png";